module.exports = __webpack_public_path__ + "img/Multimedia & Technik.9fc5eece.jpg";